export const apiVersion = "v3";
export const backendBaseUrl = import.meta.env.DEV
  ? "http://localhost:3000/api"
  : "https://api.valuations.lt/api";
export const rcTransactionsProdMode = !import.meta.env.DEV;
